import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupBy',
    standalone: false
})
export class GroupByPipe implements PipeTransform {
	transform(collection: any[], property: string): { [key: string]: any[] } {
		if (!collection) {
			return {};
		}

		const groupedCollection: { [key: string]: any[] } = collection.reduce((previous, current) => {
			if (!previous[current[property]]) {
				previous[current[property]] = [];
			}

			previous[current[property]].push(current);

			return previous;
		}, {});

		return groupedCollection;
	}
}
